export default "__VITE_ASSET__1UKJl_Bg__"